import React, { useEffect, useState } from 'react';
import HeaderBack from '../../components/HeaderBack/HeaderBack';
import styles from './user-activity-page.module.css';
import { getDocBd } from '../../firebase';
import LoaderPage from '../../components/LoaderPage/LoaderPage';
import { useParams } from 'react-router-dom';

export default function UserActivityPage() {
  let { user_id } = useParams();

  const [loaderPage, setLoaderPage] = useState(false);
  const [webCounterList, setWebCounterList] = useState([]);

  useEffect(() => {
    const getData = async () => {
      setLoaderPage(true);
      const docs = await getDocBd('loginWebList', user_id);
      if (docs && Object.keys(docs).length) {
        const docsKeys = Object.keys(docs);
        const items = [];
        docsKeys.forEach((itemKey) => {
          items.push(docs[itemKey]);
        });

        items.sort(function (a, b) {
          if (a.timeMilliseconds > b.timeMilliseconds) {
            return -1;
          }
          if (a.timeMilliseconds < b.timeMilliseconds) {
            return 1;
          }
          return 0;
        });

        setWebCounterList(items);
      }
      setLoaderPage(false);
    };
    getData();
  }, []);

  const getOs = (value) => {
    if (value === 'Android') {
      return (
        <svg
          height="20px"
          width="20px"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 511.797 511.797"
          xmlSpace="preserve">
          <g transform="translate(0 1)">
            <g>
              <path
                style={{
                  fill: '#B3CD4B',
                }}
                d="M386.068,128.967H125.729C129.2,91.652,165.648,24.831,256.766,24.831 C343.546,24.831,382.597,91.652,386.068,128.967"
              />
              <path
                style={{
                  fill: '#B3CD4B',
                }}
                d="M56.305,354.594L56.305,354.594c-19.092,0-34.712-15.62-34.712-34.712V198.391 c0-19.092,15.62-34.712,34.712-34.712s34.712,15.62,34.712,34.712v121.492C91.017,338.974,75.397,354.594,56.305,354.594"
              />
              <path
                style={{
                  fill: '#B3CD4B',
                }}
                d="M455.492,354.594L455.492,354.594c-19.092,0-34.712-15.62-34.712-34.712V198.391 c0-19.092,15.62-34.712,34.712-34.712c19.092,0,34.712,15.62,34.712,34.712v121.492 C490.204,338.974,474.583,354.594,455.492,354.594"
              />
              <path
                style={{
                  fill: '#B3CD4B',
                }}
                d="M351.356,397.984v86.78c0,14.753-11.281,26.034-26.034,26.034 c-14.753,0-26.034-11.281-26.034-26.034v-86.78h-86.78v86.78c0,14.753-12.149,26.034-26.034,26.034s-26.034-11.281-26.034-26.034 v-86.78h-34.712V163.679h260.339v234.305H351.356z"
              />
            </g>
            <g>
              <path
                style={{
                  fill: '#FFFFFF',
                }}
                d="M229.865,85.577c0-9.546-7.81-17.356-17.356-17.356c-9.546,0-17.356,7.81-17.356,17.356 s7.81,17.356,17.356,17.356C222.055,102.933,229.865,95.123,229.865,85.577"
              />
              <path
                style={{
                  fill: '#FFFFFF',
                }}
                d="M316.644,85.577c0-9.546-7.81-17.356-17.356-17.356s-17.356,7.81-17.356,17.356 s7.81,17.356,17.356,17.356C308.834,102.933,316.644,95.123,316.644,85.577"
              />
            </g>
            <g>
              <path
                style={{
                  fill: '#B3CD4B',
                }}
                d="M185.607,50.865c-3.471,0-6.075-1.736-7.81-5.207l-16.488-34.712 c-1.736-4.339,0-9.546,4.339-11.281c4.339-1.736,9.546,0,11.281,4.339l16.488,34.712c1.736,4.339,0,9.546-4.339,11.281 C188.211,49.997,187.343,50.865,185.607,50.865z"
              />
              <path
                style={{
                  fill: '#B3CD4B',
                }}
                d="M325.322,50.865c-0.868,0-2.603,0-3.471-0.868c-4.339-1.736-6.075-6.942-4.339-11.281L334,4.004 c1.736-4.339,6.942-6.075,11.281-4.339c4.339,1.736,6.075,6.942,4.339,11.281l-16.488,34.712 C332.265,49.129,328.794,50.865,325.322,50.865z"
              />
            </g>
          </g>
        </svg>
      );
    }
    if (value === 'IOS') {
      return (
        <svg
          width="20px"
          height="20px"
          viewBox="-1.5 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink">
          <title>{'apple [#173]'}</title>
          <desc>{'Created with Sketch.'}</desc>
          <defs />
          <g id="Page-1" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <g
              id="Dribbble-Light-Preview"
              transform="translate(-102.000000, -7439.000000)"
              fill="#000000">
              <g id="icons" transform="translate(56.000000, 160.000000)">
                <path
                  d="M57.5708873,7282.19296 C58.2999598,7281.34797 58.7914012,7280.17098 58.6569121,7279 C57.6062792,7279.04 56.3352055,7279.67099 55.5818643,7280.51498 C54.905374,7281.26397 54.3148354,7282.46095 54.4735932,7283.60894 C55.6455696,7283.69593 56.8418148,7283.03894 57.5708873,7282.19296 M60.1989864,7289.62485 C60.2283111,7292.65181 62.9696641,7293.65879 63,7293.67179 C62.9777537,7293.74279 62.562152,7295.10677 61.5560117,7296.51675 C60.6853718,7297.73474 59.7823735,7298.94772 58.3596204,7298.97372 C56.9621472,7298.99872 56.5121648,7298.17973 54.9134635,7298.17973 C53.3157735,7298.17973 52.8162425,7298.94772 51.4935978,7298.99872 C50.1203933,7299.04772 49.0738052,7297.68074 48.197098,7296.46676 C46.4032359,7293.98379 45.0330649,7289.44985 46.8734421,7286.3899 C47.7875635,7284.87092 49.4206455,7283.90793 51.1942837,7283.88393 C52.5422083,7283.85893 53.8153044,7284.75292 54.6394294,7284.75292 C55.4635543,7284.75292 57.0106846,7283.67793 58.6366882,7283.83593 C59.3172232,7283.86293 61.2283842,7284.09893 62.4549652,7285.8199 C62.355868,7285.8789 60.1747177,7287.09489 60.1989864,7289.62485"
                  id="apple-[#173]"
                />
              </g>
            </g>
          </g>
        </svg>
      );
    }
    if (value === 'Windows') {
      return (
        <svg
          fill="#5372ff"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="20px"
          height="20px"
          viewBox="0 0 512 512"
          xmlSpace="preserve">
          <g id="7935ec95c421cee6d86eb22ecd13295e">
            <path
              style={{
                display: 'inline',
              }}
              d="M106.669,52.438c0,0,102.123-55.525,189.491,11.392l-48.896,167.995 c0,0-54.756-37.67-95.361-33.602c-40.605,4.079-94.13,23.508-94.13,23.508L106.669,52.438z M0.5,420.566 c22.54-11.653,56.372-17.559,95.35-20.823c39.011-3.255,93.91,32.468,93.91,32.468l49.401-169.776 c-7.817-5.618-44.168-30.094-89.666-33.348c-45.52-3.255-100.354,22.243-100.354,22.243L0.5,420.566z M216.104,447.165 c8.928,3.519,38.22,31.38,86.972,33.854c48.763,2.419,102.541-22.749,102.541-22.749s47.894-167.6,48.861-168.249 c0.33-0.176-0.604,0.484-0.968,0.649c-45.596,17.845-68.872,20.506-102.496,21.309c-34.141,0.824-86.269-33.095-86.269-33.095 L216.104,447.165z M322.01,81.575l-48.995,167.017c0,0,39.803,39,95.867,35.768c56.098-3.267,86.532-20.945,93.976-23.442 L511.5,92.416c0,0-64.606,26.982-106.851,22.09C362.384,109.613,336.094,91.657,322.01,81.575z"
            />
          </g>
        </svg>
      );
    }
    if (value === '​ОС невстановлена') {
      return '?';
    }
  };

  const renderWebCounterList = (webCounterList) => {
    return webCounterList.map((item) => {
      return (
        <div key={item.timeMilliseconds} className={styles.activity_info_wrapper}>
          <div className={styles.activity_info_topBlock}>
            <div>{item.dateStart}</div>
            <div>{item.timeStart}</div>
            {getOs(item.isOs)}
            <div>{item.timeAnd}</div>
            <div>{item.viewTime}</div>
          </div>
          <div className={styles.userAgent}>{item.userAgent}</div>
        </div>
      );
    });
  };

  return (
    <>
      <HeaderBack />
      <div className={styles.page_wrapper}>{renderWebCounterList(webCounterList)}</div>
      {loaderPage && <LoaderPage />}
    </>
  );
}
